module.exports = __webpack_public_path__ + "img/atlaslist3img3.1be57cb8.jpg";